module.exports = __webpack_public_path__ + "img/bqtx-active.81ed413c.svg";